import { fecthGet, fecthPost, fecthDelete } from '@/hotelcem/apis/request'

export default {
  /**
   * 客诉分布
   */
  fetchComplaintDistribute(params) {
    return fecthPost('/cem/hotel/voice/warn/complaint/distribute', params)
  },
  /**
   * 客诉告警相关指标
   */
  fetchComplaintIndexStatistics(params) {
    return fecthPost('/cem/hotel/voice/warn/complain/index/statistics', params)
  },
  /**
   * OTA渠道点评分
   * @param {Object} params RequestBody
   * @returns ResponseBody
   */
  fecthCommentScore(params) {
    return fecthPost('/cem/hotel/channel/comment/score', params)
  },
  /**
   * OTA点评分排名
   * @param {Object} params RequestBody
   * @returns ResponseBody
   */
  fecthCommentScoreAvgRank(params) {
    return fecthPost('/cem/hotel/compete-analysis/avg/score/rank', params)
  },
  /**
   * OTA点评分排名
   * @param {Object} params RequestBody
   * @returns ResponseBody
   */
  fecthCompetitorRank(params) {
    return fecthPost('/cem/hotel/compete-analysis/competitor/rank', params)
  },
  /**
   * OTA点评分排名
   * @param {Object} params RequestBody
   * @returns ResponseBody
   */
  fecthCompetitorRankTrend(params) {
    return fecthPost('/cem/hotel/compete-analysis/competitor/rank/trend', params)
  },

  // 华客语义指数 -- fecthScoreDetail
  fecthSemantic(params) {
    return fecthPost('/cem/hotel/vocust/index', params)
  },
  // 观点贡献度
  fetchViewAnalysis(params) {
    return fecthPost('/cem/hotel/label/contribution', params)
  },
  // 首页无差评
  fetchNoBadComment(params) {
    params.queryTotal = false
    return fecthPost('/cem/comment/hotel/pos/days', params)
  },
  // 首页无无A/S预警
  fetchNoRecord(params) {
    return fecthPost('/warn/record/hotel/low/warn/days', params)
  },
  // 酒店是否有应用权限
  fetchHotelHasQms(params) {
    return fecthPost('/qms/task-board/whether-to-open', params)
  },
  // 检查完成数+当日检查完成数
  fetchFinishnums(params) {
    return fecthPost('/qms/task-board/check-compete-total', params)
  },
  //TQM 检查合格率+整改完成率
  fetchQmsTqm(params) {
    return fecthPost('/qms/task-board/tqm-rate', params)
  },
  //MOD检查合格率+今日检查合格率+自检完成率
  fetchQmsMod(params) {
    return fecthPost('/qms/task-board/check-pass-rate', params)
  },
  //获取首页看板微博、抖音、小红书开通状态
  fetchMediaOpenInfo(params) {
    return fecthGet('/cem/article/media/open/info', params)
  },
  // 卖点探索（热门话题 曝光量和作者分布）
  fetchHotTopice(params) {
    return fecthPost('/cem/article/read-count', params)
  },
  // 话题数量
  fetchHotTopiceNum(params) {
    return fecthPost('/cem/article/article-count', params)
  },
  //csi - 获取城市
  getCitys(params) {
    return fecthGet('/cem/hotel-rank/city/list', params)
  },
  getCSICitys(params) {
    return fecthGet('/cem/hotel-rank/csi/city', params)
  },
  //csi - 获取商圈
  getBizAreas(params) {
    return fecthGet('/cem/hotel-rank/biz-area/list', params)
  },
  getCSIBizAreas(params) {
    return fecthGet('/cem/hotel-rank/csi/biz-area', params)
  },
  //csi - 获取商圈
  getCsiHotels(params) {
    return fecthPost('/cem/hotel-rank/hotel/list', params)
  },
  getCsiHotelsNew(params) {
    return fecthPost('/cem/hotel-rank/csi/hotel/list', params)
  },

  getCsiList(params) {
    return fecthPost('/cem/hotel-rank/list', params)
  },
  getCsiListNew(params) {
    return fecthPost('/cem/hotel-rank/csi/list', params)
  },

  //csi - 详情，banner用
  // getCsiDetails(params) {
  //   return fecthGet('/cem/hotel-rank/csi/rank-info', params)
  //   // return fecthGet('/cem/hotel-rank/rank-info', params)
  // },

  getRankInfo(params) {
    return fecthGet('/cem/hotel-rank/csi/rank-info', params)
  },
  getCSIHotelScoreTrend(params) {
    return fecthPost('/cem/hotel-rank/csi/score/trend', params)
  },
  fetchAddCSIHotel(params) {
    return fecthPost('/cem/hotel-rank/csi/competitor/add', params)
  },
  /**首页页面改造start */
  // 明察暗访-集团、门店、暗访
  fetchAnFangData(params) {
    return fecthPost('/qms/task-board/check-task/statistics', params)
  },
  // 携程星球好笔记 fetchHotTopiceNum 接口添加了trendInfoList趋势图
  // CSI和点评趋势图
  fetchCommentTrendInfo(params) {
    return fecthPost('/cem/comment/trend/info', params)
  },
  fetchModuleAggregated(data) {
    return fecthPost('/data-model/aggregated', data)
  },
  // 兼容模式or进阶模式
  getMode(params) {
    return fecthGet('/cem/vocust-score-task/tenant-config/detail', params)
  },
  /**首页页面改造end */
  // 获取下线客诉总量
  getCustomWarningTotal(params) {
    return fecthPost('/hotel/info/complaint/upload/total', params)
  },
  // 获取线下客诉趋势图
  getCustomWarningTrend(params) {
    return fecthPost('/hotel/info/complaint/upload/trend', params)
  },
}
